export async function ServerRequest(name, data) {
  let key = FirebaseWorker.ref(`photoheight/server_requests/${name}/requests`).push(data).key;
  await new Promise((resolve, reject) => {
    let callback = async (s) => {
      if (s.exists()) {
        // Detach Callback.
        FirebaseWorker.ref(`photoheight/server_requests/${name}/responses/${key}`).off('value', callback);
        // Get response.
        let res = s.val();
        // Remove the response in firebase.
        await s.ref.remove();
        // Resolve if successful.
        if (res.success || (res.status && res.status.toLowerCase() === 'success')) resolve(res);
        // Otherwise, throw an error.
        else reject(res);
      }
    };
    FirebaseWorker.ref(`photoheight/server_requests/${name}/responses/${key}`).on('value', callback);
  });
}
